"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";

/** CTA strip below the teaser on the Grid Solutions job board (legacy AllJobsCTA.eon.subclient). */
export default function AllJobsCtaEonGridsolutions() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-[15px] text-black xs:text-lg lg:text-xl"><div className="bg-gray-300 px-6 py-10 md:px-10"><div className="mx-auto flex max-w-screen-xl flex-wrap justify-between gap-x-4 gap-y-4"><div className="flex"><p><span className="mr-2">Nicht der richtige Job dabei? Wir sind E.ON Grid Solutions und Part von{" "}</span><CustomImage alt="" className="inline-block w-16 md:w-20" height={50} src="images/logo/logo.svg" width={80} /></p></div><CustomLink blank={true} className="font-bold hover:underline" href="https://jobs.eon.com/">→ Zu den E.ON Jobs</CustomLink></div></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}